import _ from 'underscore';

export function generateAllowedEntities({
  i18n,
  permissions = {},
  allowedChannels = [],
  isCustomerLevel = false,
  importType = null,
  overrideEntitiesGenerator = null,
}) {
  const uetPermission = isCustomerLevel || _.contains(allowedChannels, importType);
  const isPmaxEntityContainsInImport = isCustomerLevel || importType === 'GoogleAPIImport' || importType === 'GoogleImport';
  const similarAudienceTargetImportPermission =
    permissions.IsSimilarAudienceTargetImportEnabled && uetPermission;
  // [MT name, UI name]
  // Please add UI name localization string into both all-string.js and legacy-string.js
  let entitiesNamesMapping = _.compact([
    ['Campaign', 'Import_ImportSummary_Campaigns'],
    ['Location Target', 'Import_ImportSummary_LocationTarget'],
    ['Ad Group', 'Import_ImportSummary_AdGroups'],
    isPmaxEntityContainsInImport && ['Asset Group', 'Import_ImportSummary_AssetGroups'],
    isPmaxEntityContainsInImport && ['Asset Group Listing Group', 'Import_ImportSummary_ListingGroups'],
    isPmaxEntityContainsInImport && ['Audience Group', 'Import_ImportSummary_AudienceGroups'],
    ['Ad', 'Import_ImportSummary_Ads'],
    ['Keyword', 'Import_ImportSummary_Keywords'],
    ['Ad Extension', 'Import_ImportSummary_AdExtensions'],
    ['Ad Group Product Partition', 'Import_ImportSummary_ProductPartition'],
    ['Campaign Product Scope', 'Import_ImportSummary_CampaignCriterions'],
    ['Campaign Negative Dynamic Search Ad Target', 'Import_ImportSummary_CampaignDSACriterion'],
    ['AdGroup DSA Criterion', 'Import_ImportSummary_AdGroupDSACriterion'],
    ['Account Shared Negative Keyword', 'Import_ImportSummary_AccountSharedNegativeKeyword'],
    ['Campaign Negative Keyword', 'Import_ImportSummary_CampaignNegativeKeyword'],
    ['Ad Group Negative Keyword', 'Import_ImportSummary_AdGroupNegativeKeyword'],
    ['Campaign Negative Site', 'Import_ImportSummary_CampaignNegativeSite'],
    ['Ad Group Negative Site', 'Import_ImportSummary_AdGroupNegativeSite'],
    ['Negative Keyword List', 'Import_ImportSummary_NegativeKeywordList'],
    ['Shared Negative Keyword', 'Import_ImportSummary_SharedNegativeKeyword'],
    ['Image', 'Import_ImportSummary_Images'],
    ['Campaign DeviceOS Criterion', 'Import_ImportSummary_CampaignDeviceTargets'],
    ['Ad Group DeviceOS Criterion', 'Import_ImportSummary_AdGroupDeviceTargets'],
    ['Campaign DayTime Criterion', 'Import_ImportSummary_CampaignDayTimeTargets'],
    ['Ad Group DayTime Criterion', 'Import_ImportSummary_AdGroupDayTimeTargets'],
    ['Campaign Location Criterion', 'Import_ImportSummary_CampaignLocationTargets'],
    ['Ad Group Location Criterion', 'Import_ImportSummary_AdGroupLocationTargets'],
    ['Campaign Negative Location Criterion', 'Import_ImportSummary_CampaignNegativeLocationTargets'],
    ['Ad Group Negative Location Criterion', 'Import_ImportSummary_AdGroupNegativeLocationTargets'],
    ['Campaign Location Intent Criterion', 'Import_ImportSummary_CampaignLocationIntentTargets'],
    ['Ad Group Location Intent Criterion', 'Import_ImportSummary_AdGroupLocationIntentTargets'],
    ['Campaign Radius Criterion', 'Import_ImportSummary_CampaignRadiusTargets'],
    ['Ad Group Radius Criterion', 'Import_ImportSummary_AdGroupRadiusTargets'],
    ['Campaign Age Criterion', 'Import_ImportSummary_CampaignAgeTargets'],
    ['Ad Group Age Criterion', 'Import_ImportSummary_AdGroupAgeTargets'],
    ['Ad Group Negative Age Criterion', 'Import_ImportSummary_AdGroupNegativeAgeTargets'],
    ['Campaign Gender Criterion', 'Import_ImportSummary_CampaignGenderTargets'],
    ['Ad Group Gender Criterion', 'Import_ImportSummary_AdGroupGenderTargets'],
    ['Ad Group Negative Gender Criterion', 'Import_ImportSummary_AdGroupNegativeGenderTargets'],
    permissions.IsCampaignAudienceTargetGoogleImportEnabled && uetPermission && ['Campaign In Market Audience Association', 'Import_ImportSummary_CampaignAudienceTargets'],
    ['Ad Group In Market Audience Association', 'Import_ImportSummary_AdGroupAudienceTargets'],
    permissions.IsCampaignAudienceTargetGoogleImportEnabled && uetPermission && ['Campaign Negative In Market Audience Association', 'Import_ImportSummary_CampaignNegativeAudienceTargets'],
    ['Ad Group Negative In Market Audience Association', 'Import_ImportSummary_AdGroupNegativeAudienceTargets'],
    ['Feed', 'Import_ImportSummary_Feeds'],
    ['Feed Item', 'Import_ImportSummary_FeedItems'],
    ['Brand List', 'Import_ImportSummary_BrandList'],
    ['Brand Item', 'Import_ImportSummary_BrandItem'],
    ['Campaign Brand List Association', 'Import_ImportSummary_CampaignBrandListAssociation'],
    ['Others', 'Import_ImportSummary_Others'],
    ['Smart Listing', 'Import_ImportSummary_SmartListing'],
    uetPermission && ['Remarketing List', 'Import_ImportSummary_RemarketingList'],
    uetPermission && ['Combined List', 'Import_ImportSummary_CombinedList'],
    uetPermission && ['Ad Group Remarketing List Association', 'Import_ImportSummary_AdGroupRemarketingListTargets'],
    uetPermission && ['Ad Group Negative Remarketing List Association', 'Import_ImportSummary_AdGroupNegativeRemarketingListTargets'],
    uetPermission && ['Campaign Remarketing List Association', 'Import_ImportSummary_CampaignRemarketingListTargets'],
    uetPermission && ['Campaign Negative Remarketing List Association', 'Import_ImportSummary_CampaignNegativeRemarketingListTargets'],
    uetPermission && ['Ad Group Combined List Association', 'Import_ImportSummary_AdGroupCombinedListTargets'],
    uetPermission && ['Ad Group Negative Combined List Association', 'Import_ImportSummary_AdGroupNegativeCombinedListTargets'],
    uetPermission && ['Campaign Combined List Association', 'Import_ImportSummary_CampaignCombinedListTargets'],
    uetPermission && ['Campaign Negative Combined List Association', 'Import_ImportSummary_CampaignNegativeCombinedListTargets'],
    similarAudienceTargetImportPermission && ['Ad Group Similar Remarketing List Association', 'Import_ImportSummary_AdGroupSimilarRemarketingListTargets'],
    similarAudienceTargetImportPermission && ['Ad Group Negative Similar Remarketing List Association', 'Import_ImportSummary_AdGroupNegativeSimilarRemarketingListTargets'],
    similarAudienceTargetImportPermission && ['Campaign Similar Remarketing List Association', 'Import_ImportSummary_CampaignSimilarRemarketingListTargets'],
    similarAudienceTargetImportPermission && ['Campaign Negative Similar Remarketing List Association', 'Import_ImportSummary_CampaignNegativeSimilarRemarketingListTargets'],
    permissions.dynamic && permissions.dynamic.RSAAdCustomizerEnhancement && ['Adcustomizer Attribute', 'Import_ImportSummary_AdCustomizerAttributes'],
    permissions.IsGoogleConversionGoalsImportEnabled && ['Conversion Goal', 'Import_ImportSummary_ConversionGoals'],
  ]);

  // get new entitiesNamesMapping if override generator exists
  if (overrideEntitiesGenerator) {
    entitiesNamesMapping = overrideEntitiesGenerator(entitiesNamesMapping, permissions);
  }

  const allowedList = _.reduce(entitiesNamesMapping, (memo, entityItem) => {
    const MTName = entityItem[0];
    const UINameKey = entityItem[1];

    memo.push({
      MTName,
      UIName: i18n && i18n.getString(UINameKey),
      UINameKey,
    });
    return memo;
  }, []);

  return allowedList;
}
